import { styled, TextField } from "@mui/material";
import { baseGrey } from "../../graphic/theme";

const StyledTextField = (props) => {
  return (
    <BlackTextField
      {...props}
      id="outlined-basic"
      variant="outlined"
      color="textField"
      sx={{
        width: "100%",
        mr: "10px",
        opacity: "1",
        "& .MuiInputBase-root": {
          background: baseGrey,
        },
        "& .MuiInputBase-input": {
          fontWeight: "bold",
          fontSize: "14px",
          color: "black",
          opacity: "1",
          "&::placeholder": {
            fontSize: "14px",
            opacity: 0.7,
          },
        },
      }}
      InputLabelProps={{
        sx: {},
      }}
    />
  );
};

const BlackTextField = styled(TextField)({
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: `transparent !important`,
  },
});

export default StyledTextField;
